<style lang="scss" type="stylesheet/scss" scoped>
@import "@/assets/var.scss";

.layout-header {
  height: 120px;
  font-size: 0;
  .logo {
    width: 147px;
    height: 68px;
    display: inline-block;
    margin-top: 26px;
    vertical-align: top;
  }
  .title {
    font-size: 30px;
    line-height: 120px;
    margin: 0 0 0 44px;
    display: inline-block;
    color: $mainBlue;
    font-weight: bold;
    span {
      cursor: pointer;
    }
  }
  .triggler {
    display: inline-block;
    margin-left: 22px;
    font-size: 20px;
    line-height: 120px;
    color: $mainBlue;
    cursor: pointer;
    vertical-align: top;
    i {
      border-radius: 50%;
      border: solid 2px $mainBlue;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      margin-right: 5px;
      transform: rotate(90deg);
    }
  }
}
</style>

<template>
  <div class="layout-header">
    <my-wrapper>
      <a :href="$store.state.urls.SHOP_HOME_URL">
        <img src="@/assets/images/logo.png"
             class="logo">
      </a>
      <div class="title">
        <span @click="$router.push(`${role === 'buyer' ? '/buyer' : '/seller'}`)">{{role === 'buyer' ? '买家' : '卖家'}}中心
        </span> | {{$route.meta.title}}
      </div>
      <div class="triggler"
           @click="$router.push(`${role === 'buyer' ? '/seller' : '/buyer'}`)">
        <i class="el-icon-sort"></i>
        <span class="triggler-text">切换到{{role !== 'buyer' ? '买家' : '卖家'}}</span>
      </div>
    </my-wrapper>
  </div>
</template>

<script type="text/ecmascript-6">
import { ROLE_ENUM } from "@/utils";
export default {
  name: "layout-header",
  props: ["role"],
  data() {
    return {};
  },
};
</script>
